/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import { ArrayExtensions, ObjectExtensions } from '@msdyn365-commerce-modules/retail-actions';
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { IProductSpecificationViewProps } from './cip-product-specification';

const ProductSpecificationView: React.FC<IProductSpecificationViewProps> = props => {
    const {
        ProductSpecification,
        ProductSpecificationTableProps,
        ProductSpecificationTableHeadProps,
        ProductSpecificationTableBodyProps,
        ProductSpecificationTableRowProps,
        productSpecificationResult,
        productSpecificationHeaderResult,
        isAccordion,
        isVertical
    } = props;
    const headdata =
        productSpecificationHeaderResult &&
        ArrayExtensions.hasElements(productSpecificationHeaderResult) &&
        productSpecificationHeaderResult.filter(row => !ObjectExtensions.isNullOrUndefined(row));

    const rowdata =
        productSpecificationResult &&
        ArrayExtensions.hasElements(productSpecificationResult) &&
        productSpecificationResult.filter(row => !ObjectExtensions.isNullOrUndefined(row));

    return rowdata && ArrayExtensions.hasElements(rowdata) ? (
        <Module {...ProductSpecification}>
            {props.title}
            <Node {...ProductSpecificationTableProps}>
                {isAccordion ? (
                    <Node {...ProductSpecificationTableBodyProps}>{rowdata}</Node>
                ) : isVertical ? (
                    <Node {...ProductSpecificationTableBodyProps}>{rowdata}</Node>
                ) : (
                    <Node {...ProductSpecificationTableBodyProps}>
                        <Node {...ProductSpecificationTableHeadProps}>{headdata}</Node>
                        <Node {...ProductSpecificationTableRowProps}>{rowdata}</Node>
                    </Node>
                )}
            </Node>
        </Module>
    ) : null;
};

export default ProductSpecificationView;
